// src/components/sections/HeroSection.js
import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, BadgeCheck } from 'lucide-react';
import statsData from '../../data/stats';
import StKzPdf from '../../assets/CT-KZ-Certificate.pdf'; // Import the PDF

/**
 * HeroSection component displays the main banner with an entrance animation.
 * @return {React.ReactElement} The HeroSection component.
 */
const HeroSection = () => {
  const handleScrollToProductSection = () => {
    const headerOffset = 80;
    const element = document.getElementById('продукция'); // The ID of your products section
    if (element) {
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section id="главная" className="pt-32 pb-16 relative overflow-hidden">
      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          className="text-center max-w-4xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="mb-8">
            <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold text-gray-800 mb-6 leading-normal sm:leading-tight">
              Текстильные стропы
              <span className="text-orange-500 block mt-2 sm:mt-0">напрямую от производителя</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto leading-relaxed">
              Мы не перепродаем — мы производим. Получите стропы с гарантией качества, без наценок и
              с подтверждённым сертификатом происхождения <span className="font-bold">СТ-KZ</span>.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12">
            <button
              onClick={handleScrollToProductSection} // Changed to onClick and calling the function
              className="bg-orange-500 text-white px-8 py-4 rounded-full font-semibold text-lg shadow-xl flex items-center gap-2 hover:bg-orange-600 transition-colors"
            >
              Смотреть каталог <ArrowRight className="w-5 h-5" />
            </button>
            <a
              href={StKzPdf}
              target="_blank"
              className="border-2 border-orange-500 text-orange-500 px-8 py-4 rounded-full font-semibold text-lg hover:bg-orange-500 hover:text-white transition-colors flex items-center gap-2"
              rel="noreferrer"
            >
              <BadgeCheck className="w-5 h-5" /> Сертификат СТ-KZ
            </a>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-2xl mx-auto">
            {statsData.map((stat, index) => (
              <div key={index} className="text-center group p-4 rounded-lg">
                <div className="text-2xl md:text-3xl font-bold text-gray-800 mb-2 group-hover:text-orange-500 transition-colors">
                  {stat.value}
                </div>
                <div className="text-gray-600 text-sm">{stat.label}</div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
